import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stepper, Step, StepLabel, StepButton } from '@material-ui/core';
import styles from './WizardProgress.module.scss';

const WizardProgress = ({ steps, currentStep, completedSteps, onStepClick, variant }) => {
  const isStepCompleted = (stepIndex) => stepIndex < currentStep;
  const isStepAccessible = (stepIndex) => stepIndex <= currentStep || isStepCompleted(stepIndex);
  return (
    <Box className={`${styles.root} ${variant === 'cloud' ? styles.cloud : ''}`}>
      <Stepper activeStep={currentStep}>
        {steps.map((step, index) => {
          const completed = isStepCompleted(index);
          const accessible = isStepAccessible(index);

          return (
            <Step key={step.id} completed={completed}>
              {accessible ? (
                <StepButton onClick={() => onStepClick && onStepClick(index)}>
                  <StepLabel
                    StepIconProps={{
                      className: styles.stepIcon,
                      classes: {
                        active: 'active',
                        completed: 'completed',
                      },
                    }}
                  >
                    {step.title}
                  </StepLabel>
                </StepButton>
              ) : (
                <StepLabel
                  StepIconProps={{
                    className: styles.stepIcon,
                  }}
                >
                  {step.title}
                </StepLabel>
              )}
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};

WizardProgress.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  currentStep: PropTypes.number.isRequired,
  completedSteps: PropTypes.arrayOf(PropTypes.number),
  onStepClick: PropTypes.func,
  variant: PropTypes.oneOf(['default', 'cloud']),
};

WizardProgress.defaultProps = {
  completedSteps: [],
  onStepClick: null,
  variant: 'default',
};

export default WizardProgress;
